const middleware = {}

middleware['magic'] = require('../middleware/magic.js')
middleware['magic'] = middleware['magic'].default || middleware['magic']

middleware['order'] = require('../middleware/order.js')
middleware['order'] = middleware['order'].default || middleware['order']

middleware['redirects'] = require('../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

middleware['shop'] = require('../middleware/shop.js')
middleware['shop'] = middleware['shop'].default || middleware['shop']

export default middleware
